import { SET_TRANSLATIONS } from './translationActions';

export function translationReducer(state, action) {
	switch (action.type) {
		case SET_TRANSLATIONS:
			return action.t10s;
		default:
			throw new Error(`Unhandled translation action type: ${action.type}`);
	}
}

export const T10S_DEFAULT_STATE = {
	translate: key => {
		return key;
	}
};
